// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".creatorPlaylist_root__2gHrf {\n  width: 320px;\n  background: #fff;\n  border-radius: 15px;\n  margin-top: 10px;\n  padding: 20px;\n  box-shadow: 2px 1px 11px 3px rgba(181, 181, 181, 0.4);\n  height: calc(100vh - 339px); }\n", ""]);
// Exports
exports.locals = {
	"root": "creatorPlaylist_root__2gHrf"
};
module.exports = exports;
